import moment from "moment";
import AppConfig from "../../AppConfig";
import TableStatus from "../../data/types/TableStatus";
import { DATETIME_FORMAT, escapeRegexp, hasItems } from "../../helpers/Utils";
import MarketApiHelper from "../../weave/MarketApiHelper";
import { ActionTypes } from "../constants/index";
import LOCAL_STORAGE from "../localStorage";

// ------------------------------------- GET -------------------------------------
const getDummyMarketListings = (dispatch, products = [], filters = {}) => {
	const { searchText, categories } = filters;

	let filteredListings = products || [];

	// Filter by search text
	if (searchText) {
		const pattern = new RegExp(
			escapeRegexp(searchText).split(" ").join("|"),
			"gi"
		);
		filteredListings = filteredListings.filter((a) => {
			return (
				a.title?.match(pattern) ||
				a.description?.match(pattern) ||
				a.full_description?.match(pattern) ||
				a.category?.match(pattern)
			);
		});
	}

	// Filter by categories
	if (hasItems(categories)) {
		filteredListings = filteredListings.filter((a) =>
			categories.includes(a.category.toLocaleLowerCase())
		);
	}

	dispatch({
		type: ActionTypes.MARKET_FETCH_LISTINGS_SUCCESS,
		isFetching: false,
		listings: filteredListings,
	});
};

const _requestFetchListings = () => {
	return {
		type: ActionTypes.FETCH_LISTINGS_REQUEST,
		isFetching: true,
	};
};

export const fetchMarketListings = (filters) => {
	return (dispatch) => {
		let stateData = LOCAL_STORAGE.loadState() || {};

		dispatch(_requestFetchListings());

		// DUMMY DATA
		if (stateData.useMocks) {
			// TODO: remove after demo: if user already uploaded demo market file
			if (stateData.marketListings) {
				getDummyMarketListings(dispatch, stateData.marketListings, filters);
			} else {
				// Default dummy listings
				import("../../mocks/market-products")
					.then((PRODUCTS) => {
						getDummyMarketListings(dispatch, PRODUCTS.default, filters);
					})
					.catch(function (error) {
						console.log(error);
					});
			}
		} else {
			const weaves = {};
			MarketApiHelper.readWeaves(filters).then((wres) => {
				(wres.data || []).forEach((w) => {
					weaves[w.bootstrap_node] = w;
				});

				MarketApiHelper.readDatasets().then((res) => {
					if (!res || !res.data) {
						console.log(res);
						return;
					}

					const datasets = res.data.map((d) => {
						//console.log(d);
						return {
							...d,
							author: d.owner,
							title: d.name,
							dataset_logo: d.logo,
							weave: weaves[d.weave],
						};
					});
					//console.log(datasets);
					dispatch({
						type: ActionTypes.MARKET_FETCH_LISTINGS_SUCCESS,
						isFetching: false,
						listings: datasets,
					});
				});
			});
		}
	};
};

export const fetchMarketListingById = (id) => {
	return (dispatch) => {
		let stateData = LOCAL_STORAGE.loadState() || {};

		// DUMMY DATA
		if (stateData.useMocks) {
			// Default dummy listings
			import("../../mocks/market-products")
				.then((PRODUCTS) => {
					const listings = stateData.marketListings || PRODUCTS.default;
					let listing = listings.find((s) => 1 * s.id === 1 * id);
					if (!listing) listing = PRODUCTS.default[0];

					dispatch({
						type: ActionTypes.MARKET_GET_LISTING_SUCCESS,
						isFetching: false,
						listing,
					});
				})
				.catch(function (error) {
					console.log(error);
				});
		} else {
			const weaves = {};
			MarketApiHelper.readWeaves({ id }).then((res) => {
				(res.data || []).forEach((w) => {
					weaves[w.bootstrap_node] = w;
				});

				// TODO:
				MarketApiHelper.readDatasets().then((res) => {
					const listing = (res.data || []).find((d) => d.id === 1 * id) || {};

					dispatch({
						type: ActionTypes.MARKET_GET_LISTING_SUCCESS,
						listing: {
							...listing,
							author: listing.owner,
							title: listing.name,
							dataset_logo: listing.logo,
							weave: weaves[listing.weave],
						},
					});
				});
			});
		}
	};
};

// For demo data
export const setMarketListings = (listings) => {
	let oldState = LOCAL_STORAGE.loadState() || {};

	LOCAL_STORAGE.saveState({
		...oldState,
		marketListings: listings,
	});

	return (dispatch) => {
		dispatch({
			type: ActionTypes.MARKET_FETCH_LISTINGS_SUCCESS,
			isFetching: false,
			listings,
		});
	};
};

export const setMarketDraftListing = (draftListing) => {
	return (dispatch) => {
		return new Promise((resolve) => {
			dispatch({
				type: ActionTypes.MARKET_SET_PREVIEW_LISTING,
				isFetching: false,
				draftListing,
			});
			resolve("success");
		});
	};
};

export const saveMarketListing = (listing) => {
	const model = {
		...listing,
		status: TableStatus.published,
		publishedDate: moment().format(DATETIME_FORMAT),
		marketplaceUrl: `${AppConfig.MARKETPLACE_URL}/#/details/${listing.id}`,
	};

	return (dispatch) => {
		dispatch(setMarketDraftListing(null));

		return new Promise((resolve) => {
			dispatch({
				type: ActionTypes.MARKET_UPDATE_LISTING,
				isFetching: false,
				listing: model,
			});
			resolve(model);
		});
	};
};

// ------------------------------------- USER -------------------------------------
export const loginMarketUser = (user = {}) => {
	return (dispatch) => {
		dispatch({
			type: ActionTypes.MARKET_LOGIN_SUCCESS,
			user,
		});
	};
};

export const logoutMarketUser = () => {
	return (dispatch) => {
		return new Promise((resolve) => {
			dispatch({
				type: ActionTypes.MARKET_LOGOUT_SUCCESS,
			});
			resolve("success");
		});
	};
};
